import { useRef, useEffect } from "react";
import { Button } from "@mui/material";
import mapboxgl from "!mapbox-gl"; // eslint-disable-line import/no-webpack-loader-syntax
import { downloadFloodMap } from "api";

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

const layer = {
  id: "iggy-fema-flood-fill",
  "source-layer": "fema_flood_20210630jsonl",
  type: "fill",
  source: "iggy-fema-flood",
  layout: {
    visibility: "none",
  },
  paint: {
    "fill-color": [
      "case",
      [
        "match",
        ["get", "FLD_ZONE"],
        ["A", "A99", "AE", "AH", "AO", "V", "VE"],
        true,
        false,
      ],
      "#e55e5e", // High
      [
        "match",
        ["get", "FLD_ZONE"],
        "X",
        [
          "match",
          ["get", "ZONE_SUBTY"],
          "0.2 PCT ANNUAL CHANCE FLOOD HAZARD",
          true,
          false,
        ],
        false,
      ],
      "#fbb03b", // Moderate
      [
        "match",
        ["get", "FLD_ZONE"],
        "X",
        [
          "match",
          ["get", "ZONE_SUBTY"],
          "0.2 PCT ANNUAL CHANCE FLOOD HAZARD",
          false,
          true,
        ],
        true,
      ],
      "#223b53", // Low
      /* other */ "rgba(0,0,0,0)",
    ],
    "fill-opacity": 0.6,
  },
};

export default function RiskMap(props) {
  const mapContainer = useRef(null);
  const map = useRef(null);

  const address = props.estatedProperty.address;
  const center = [address.longitude, address.latitude];

  useEffect(() => {
    if (map.current) return;
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: "mapbox://styles/adamtsouras99/ckqws2w4w22el17mz13csjm0i",
      center,
      zoom: 14,
      preserveDrawingBuffer: true,
      interactive: false,
    });
    map.current.on("load", () => {
      map.current.loadImage("/marker.png", (error, image) => {
        if (error) throw error;
        map.current.addImage("custom-marker", image);
        map.current.addSource("points", {
          type: "geojson",
          data: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: center,
                },
              },
            ],
          },
        });
        map.current.addLayer({
          id: "points",
          type: "symbol",
          source: "points",
          layout: {
            "icon-image": "custom-marker",
          },
        });
      });
      const tiles = [
        `${process.env.REACT_APP_RISK_URL}/tiles/v1/fema_flood_all/{z}/{x}/{y}.mvt`,
      ];
      map.current.addSource("iggy-fema-flood", { type: "vector", tiles });
      map.current.addLayer(layer, "road-label");
      map.current.setLayoutProperty(layer.id, "visibility", "visible");
    });
  });

  const exportMap = () => {
    const uri = map.current.getCanvas().toDataURL("image/jpeg");
    downloadFloodMap(address, uri);
  };

  return (
    <div style={{ height: 1300, width: 2184 }}>
      <Button
        style={{ position: "absolute", zIndex: 100, margin: 8 }}
        onClick={exportMap}
        variant="contained"
      >
        Export
      </Button>
      <div ref={mapContainer} style={{ height: "100%", width: "100%" }} />
    </div>
  );
}
